import React from 'react';
import { hydrate } from 'react-dom';
import { loadableReady } from '@loadable/component';
import 'focus-visible';

import Root from 'components/Root';

import configureStore from 'store';
import { DEFAULT_LOCALE } from 'utils';
import dayjs from 'utils/dayjs';

const initialState = window.APP_INITIAL_STATE || {};
const translationsLocale = window.APP_TRANSLATIONS_LOCALE || DEFAULT_LOCALE;
const routerBasename =
  window.APP_ROUTER_BASENAME || process.env.APP_ROUTER_BASENAME;

dayjs.locale(translationsLocale);

delete window.APP_INITIAL_STATE;
delete window.APP_TRANSLATIONS_LOCALE;
delete window.APP_ROUTER_BASENAME;
delete window.APP_TEMPLATE_PARAMS;

const store = configureStore(initialState);

const translationLoaders = {
  uk: () =>
    import(/* webpackChunkName: "translations-uk" */ 'translations/uk.json'),
  ru: () =>
    import(/* webpackChunkName: "translations-ru" */ 'translations/ru.json'),
};

const loadTranslations = locale => {
  const load = translationLoaders[locale] || translationLoaders[DEFAULT_LOCALE];

  return load().then(module => module.default);
};

let messages = null;

const render = Component => {
  hydrate(
    <Component
      store={store}
      locale={translationsLocale}
      messages={messages}
      routerBasename={routerBasename}
      env="client"
    />,
    document.getElementById('root')
  );
};

// Вимкнути автоматичне відновлення позиції скролу браузером
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// Скрол на початок сторінки при завантаженні
if (typeof window !== 'undefined') {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  // Скрол при повному завантаженні сторінки
  if (document.readyState === 'complete') {
    scrollToTop();
  } else {
    window.addEventListener('load', scrollToTop);
  }

  // Додаткова перевірка через невелику затримку
  setTimeout(scrollToTop, 0);
  requestAnimationFrame(scrollToTop);
}

loadableReady(() => {
  loadTranslations(translationsLocale).then(loadedMessages => {
    messages = loadedMessages;

    if (module.hot) {
      module.hot.accept('components/Root', () => {
        const Component = require('components/Root').default; //eslint-disable-line

        render(Component);
      });
    }

    render(Root);
  });
});
